export const authReducer = (state, action) => {
  switch (action.type) {
    case "addError":
      return {
        ...state,
        user: null,
        status: "not-authenticated",
        token: null,
        errorMessage: action.payload,
      };
    case "removeError":
      return {
        ...state,
        errorMessage: "",
      };

    case "setError":
      return {
        ...state,
        errorMessage: action.payload,
      };

    case "signIn":
      return {
        ...state,
        errorMessage: "",
        status: "authenticated",
        token: action.payload.token,
        tokenDecoded: action.payload.tokenDecoded
      };
    case "signUp":
      return {
        ...state,
        errorMessage: "",
        status: "registred",
        token: action.payload.token,
        tokenDecoded: action.payload.tokenDecoded
      };
    case "logout":
    case "notAuthenticated":
      return {
        ...state,
        status: "not-authenticated",
        token: null,
        user: null,
      };

    case "passwordRecovery":
      return {
        ...state,
        errorMessage: "",
        status: "created",
        token: action.payload.token,
        tokenDecoded: action.payload.tokenDecoded,
        deliveryOptions: action.payload.deliveryOptions
      };

    case "setLoading":
      return {
        ...state,
        loading: action.payload
      };

    case "setRefreshToken":
      return {
        ...state,
        token: action.payload.token,
        tokenDecoded: action.payload.tokenDecoded,
        refreshToken: action.payload.refreshToken,
      }

    case "permissions":
      return {
        ...state,
        permissions: action.payload
      }

    case "cart":
      return {
        ...state,
        cart: action.payload
      }


    case "contacts":
      return {
        ...state,
        contacts: action.payload
      }

    case "filtredContacts":
      return {
        ...state,
        contacts: action.payload
      }

    case "profilePicture":
      return {
        ...state,
        profilePicture: action.payload
      }

    case "setAlert":
      return {
        ...state,
        alert: action.payload
      }

    case "navigation":
      return {
        ...state,
        navigation: action.payload
      }

    case "kycAlert":
      return {
        ...state,
        kycAlert: action.payload
      }

    case "kycAlert":
      return {
        ...state,
        kycAlert: action.payload
      }

    case "preferredName":
      return {
        ...state,
        preferredName: action.preferredName
      }

    case "reset":
      return {
        status: "checking",
        token: null,
        tokenDecoded: null,
        refreshToken: null,
        navigation: {
          flux: "",
          actualScreen: "",
          previousScreen: "",
          previousState: null
        },
        kycAlert: {
          enabled: false,
          type: ""
        },
        user: null,
        alert: {
          title: "",
          message: "",
          type: "",
          enabled: false,
          okButtonTitle: "Entendido",
          okButtonclassName: null,
          continueAction: () => { }
        },
        errorMessage: "",
        permissions: [],
        cart: [],
        contacts: [],
        filtredContacts: [],
        profilePicture: "https://dev-app.tufiado.com/user/resources/profile.png"
      }

    case "createCardFlux" :
      return {
        ...state,
        createCardFlux:action.payload
      }

    default:
      return state;
  }
};
